// extracted by mini-css-extract-plugin
export var breakpointSM = "768px";
export var breakpointXS = "480px";
export var breakpoints = "'@theme/breakpoints.module.css'";
export var colors = "'@theme/colors.module.css'";
export var squant = "#666666";
export var style_component = "CardList-module--style_component--dced9";
export var style_padded = "CardList-module--style_padded--b0fb6";